import { CandidateAWebDto, CandidateUsername, CompanyCandidate } from '@generated/graphql';

// eslint-disable-next-line import/prefer-default-export
export const getIsNeedToGoToConfirmUserData = (
  me: Pick<CandidateAWebDto, 'agreement'> & {
    candidateUsername: Pick<CandidateAWebDto['candidateUsername'], 'login' | 'email'>;
  },
) => {
  return !me.agreement;
};

export const getIsNotCompanyCandidate = (
  user?: {
    firstCompanyCandidate?: Pick<CompanyCandidate, 'id'> | null;
    candidateUsername?: Pick<CandidateUsername, 'id'> | null;
  } | null,
) => {
  return !user?.firstCompanyCandidate && user?.candidateUsername;
};

export const getIsEmailNeedToBeConfirmed = (
  user?: {
    firstCompanyCandidate?: Pick<CompanyCandidate, 'id'> | null;
    candidateUsername?: Pick<CandidateUsername, 'id' | 'email' | 'emailIsConfirmed'> | null;
  } | null,
) => {
  return user?.candidateUsername?.email && user?.candidateUsername.emailIsConfirmed === false;
};
